import { render, staticRenderFns } from "./prods.vue?vue&type=template&id=5210c74b&scoped=true"
import script from "./prods.vue?vue&type=script&lang=js"
export * from "./prods.vue?vue&type=script&lang=js"
import style0 from "./prods.vue?vue&type=style&index=0&id=5210c74b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210c74b",
  null
  
)

export default component.exports